module.exports = __webpack_public_path__ + "img/bg-icho-right.dd719ffe.svg";